export const SwiperData1 = [
  {
    name: "boAt Rockerz 255R Pro in Ear Bluetooth Neckband with Upto 10 Hours Playback, ASAP Charge, IPX5, boAt Signature Sound & Integrated Controls(Active Black)",
    img: "https://www.reliancedigital.in/medias/boAt-Rockerz-255-Pro-Active-Bluetooth-Earphones-492912673-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzMzcwNHxpbWFnZS9qcGVnfGltYWdlcy9oYTAvaGE3Lzk4MzIxMDEwODUyMTQuanBnfDJkNjAyYzhmNjBmMTIzYTRmZGNjMmJhZWEyY2ZiYzNkYmY3MjM1NjUwODIyOTNjNzg1YzE5MzFkNjc0ZWI2NDg",
    price: "1,099.00",
    mrp: "3,499.00",
    discount: "69%(₹2,400)",
    id: 1,
  },
  {
    name: "boAt Airdopes 131 RTL Twin Wireless Earbuds with IWP Technology, Bluetooth V5.0, Immersive Audio, Up to 15H Total Playback, Instant Voice Assistant and Type-C Charging",
    img: "https://www.reliancedigital.in/medias/boAt-Airdopes-131-RTL-Earbuds-491973401-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w1ODM2fGltYWdlL2pwZWd8aW1hZ2VzL2g2OC9oYzgvOTgzMjI2MTg3Nzc5MC5qcGd8ZmIzMWZlZDQxNGRiYmQ1YWVjYTNmNDM3MTc4MGNlYmNlYjg1NTZmNDA0NzAzOTY5NmQyNjYyNmJhOWIwZGMxYg",
    price: "1,099.00",
    mrp: "2,990.00",
    discount: "63%(₹1,891)",
    id: 2,
  },
  {
    name: "Apple MME73HN/A 3rd Generation Airpods with Mic and Wireless Charging Case, White",
    img: "https://www.reliancedigital.in/medias/Apple-Airpods-492571632-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMTQ1NnxpbWFnZS9qcGVnfGltYWdlcy9oMjgvaGU2Lzk4MjU2MDg5OTA3NTAuanBnfGU0MjZmMjM3YjYwMDhkYmUxOWIwYjllNTczODI0YzdjY2EyYTMyYjY5MTQ3ZTE4Y2I2YzEwNGMyN2Q1N2MwMzU",
    price: "18,500.00",
    id: 3,
  },
  {
    name: "boAt Airdopes 148 True Wireless Airdopes, Active Black",
    img: "https://www.reliancedigital.in/medias/boAt-Airdopes148-TrueWireless-492579512-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxODQxNHxpbWFnZS9qcGVnfGltYWdlcy9oODMvaDIwLzk4MTY0MDE1MTA0MzAuanBnfDA2YzYxZGIxZmViZGE4MmY4ZTI0MTI0MmNhMDY1YzYzYTI1NjQzZjY4YWMyY2ZkNjNhYWYzZTUwNTE0NmE1Yzk",
    price: "1,299.00",
    mrp: "4,490.00",
    discount: "71%(₹3,191)",
    id: 4,
  },
  {
    name: "OnePlus Nord Buds Wireless Earbuds with 4 Mics and AI Noise Reduction, Black Slate",
    img: "https://www.reliancedigital.in/medias/OnePlus-NORD-BUDS-True-Wireless-492912670-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxODg4OHxpbWFnZS9qcGVnfGltYWdlcy9oOWMvaGIyLzk4MzQ2NzI4MTYxNTguanBnfGM1NTZmODdmODNkMTQ2ZDUyNjU4MGQzMzY1YzM2OTBiNzYyZjdhYzQxY2UxZWQwOGMzMzBkNTdlZmNlOGNjODg",
    price: "2,499.00",
    mrp: "2,999.00",
    discount: "17%(₹500)",
    id: 5,
  },
  {
    name: "boAt Airdopes 131 RTL Twin Wireless Earbuds with IWP Technology, Bluetooth V5.0, Immersive Audio, Up to 15H Total Playback, Instant Voice Assistant and Type-C Charging, Black",
    img: "https://www.reliancedigital.in/medias/boAt-Airdopes-131-Airdopes-492912674-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0ODcwfGltYWdlL2pwZWd8aW1hZ2VzL2hmYi9oZmMvOTkwNDQ3MzE3ODE0Mi5qcGd8YWQ4ZTg0NDAwMjg3M2Q2NDQwMzRlNTVjNzA3NDU5MDkyZTE5NzY1MzZmNGY2ODY5OWZiYzVkOWEzOTQ2OWU3YQ",
    price: "1,099.00",
    mrp: "2,990.00",
    discount: "63%(₹1,891)",
    id: 6,
  },
  {
    name: "OnePlus Bullets Z2 Wireless Neckband Earphone with AI Noise Cancellation, Magico Black",
    img: "https://www.reliancedigital.in/medias/OnePlus-Bullets-Z2-Wireless-Earphone-492796790-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w4MTk1fGltYWdlL2pwZWd8aW1hZ2VzL2hjNi9oMDkvOTgzODE4MDA0MDczNC5qcGd8NWRkMjEyZjQxMTBkYzliZmY1ZTA0NTIwMmQ3MWMxZjgyMDE3ZjdiMjVmMmFjNGY1OTg4NWNjNDU0NTY0MzdlOA",
    price: "1,699.00",
    mrp: "2,290.00",
    discount: "26%(₹591)",
    id: 7,
  },
  {
    name: "pTron InTunes Classic Bluetooth 5.2 Wireless Neckband Earphones with 24Hrs Playback Time, Made in India, Hi-Fi Stereo Audio, Deep Bass, Type-C Fast Charging, Voice Assistant, IPX4 & In-line Music & Call Controls (Black)",
    img: "https://www.reliancedigital.in/medias/pTron-InTunes-Classic-Bluetoth-Earphones-493285627-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzMTQ1OHxpbWFnZS9qcGVnfGltYWdlcy9oNzQvaGYxLzk4Njc1ODE2NTMwMjIuanBnfGNlMjliN2RhOGFiMmE1ZThjZDhhZjhhOTZlZWYxYTgzMjcyNzQyZGViZTE2YzdkMDkxZGI3YTQyMjQwYTIzM2I",
    price: "499.00",
    mrp: "1,899.00",
    discount: "74%(₹1,400)",
    id: 8,
  },
  {
    name: "pTron Basspods P181 Bluetooth 5.1 Wireless Headphones, 32Hrs Total Playtime, Immersive Stereo Sound, Stereo Calls, Snug-fit TWS Earbuds, Touch Controls, Voice Assistance, Type-C Fast Charging & IPX4 (Black)",
    img: "https://www.reliancedigital.in/medias/pTron-Basspods-P181-Bluetooth-Earphones-492796965-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0MjMyM3xpbWFnZS9qcGVnfGltYWdlcy9oYWIvaDlmLzk4MjU4OTQ4MjYwMTQuanBnfDFiNDA1MjIwOGNkMjM4YmVmYThiMjY2OWEyMzg3OWRmNDQ3MDBhYzMwYjcxOTMyZWEwNmRhMDQyMWMyMDZmZTk",
    price: "649.00",
    mrp: "2,999.00",
    discount: "78%(₹2,350)",
    id: 9,
  },
  {
    name: "Apple MLWK3HN/A Airpods Pro with Magsafe Charging Case, White",
    img: "https://www.reliancedigital.in/medias/Apple-Airpods-pro-492571631-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMTAyNnxpbWFnZS9qcGVnfGltYWdlcy9oZjgvaDg3Lzk4MjU2MDg2NjMwNzAuanBnfGRlN2MxYjQxYWMyMmU1MzFlY2E0NzkxNGQ4ZjNmNTJhZGExZjIxODQ4MTZkMjA5ZmE2YWU1N2FmNmJhOWJkYjM",
    price: "20,990.00",
    mrp: "26,300.00",
    discount: "20%(₹5,310)",
    id: 10,
  },
];
export const SwiperData2 = [
  {
    name: "HP 14s-dr3001TU Laptop (Intel Pentium Silver N6000/8 GB/256 GB SSD/UHD Graphics/Windows 11 Home/MSO/HD), 35.6 cm (14 inch)",
    img: "https://www.reliancedigital.in/medias/Hp-681Y7PA-ACJ-Laptop-493178767-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNjAxOXxpbWFnZS9qcGVnfGltYWdlcy9oYTQvaDU2Lzk5MjM5NDA2MTQxNzQuanBnfGEzZDE5OGQxNmY4M2FkMGUxODU2OTg4MDdkOTFkMmZlYmJmZjdiMDAzZTVhYzBiZmVmNThiMmYwYzhmMTkyNGI",
    price: "32,999.00",
    mrp: "37,000.00",
    discount: "11%(₹4,001)",
    id: 1,
  },
  {
    name: "HP 15s-er1501AU Standard Laptop (AMD Ryzen 3 3250U/8 GB/256 GB SSD/Radeon Graphics/Windows 11 Home/MSO/HD), 39.62 cm (15.6 Inch)",
    img: "https://www.reliancedigital.in/medias/HP-ER1501AU-Laptop-493178397-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w1ODU4NnxpbWFnZS9qcGVnfGltYWdlcy9oNmUvaDIyLzk5MDE1NTA5Mjc5MDIuanBnfDlkOGRhZGEyOWMyZWQzNTI2YTc4ZTY5ODJhYjBlNTRlZDg5YmQ5YTczM2Q2MTg0ZGRkYTE3Y2IyMmI1NTQzMDY",
    price: "28,990.00",
    mrp: "41,204.00",
    discount: "30%(₹12,214)",
    id: 2,
  },
  {
    name: "Lenovo L2IN IdeaPad 3 Laptop (11th Gen Intel Core i3-1115G4 /8GB/256GB SSD/Intel UHD Graphics/Windows 11/MSO/Full HD), 39.62 cm (15.6 inch)",
    img: "https://www.reliancedigital.in/medias/Lenovo-L2IN-Laptops-492574725-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2MTQ2NnxpbWFnZS9qcGVnfGltYWdlcy9oZmIvaGQyLzk3NDczMjk5NzQzMDIuanBnfDMxMDY2NDQ1MjE3ZDFjOTZiNjRmYTE0NTlhNmYzMWZmNGNjNjY3NzhkZjE2MTdlZTZmMzE2Yjc3NDBmNjYwMGU",
    price: "35,499.00",
    mrp: "59,390.00",
    discount: "40%(₹23,891)",
    id: 3,
  },
  {
    name: "HP 15s-fq2670TU Laptop (11th Gen Intel Core i3-1115G4/8 GB RAM/256 GB SSD/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 inch)",
    img: "https://www.reliancedigital.in/medias/Hp-6N043PA-ACJ-Laptop-493177597-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyOTkyOHxpbWFnZS9qcGVnfGltYWdlcy9oNjIvaDZhLzk4ODIyODk1MzcwNTQuanBnfDAzZjY0ZjBmY2RmNWY0YzBiMWU5MGQ1YTkxYWIxMmVhZGJmYTdkNDFkYWRiMGMwNzNhOTlhNzFmM2EzNWQxZGE",
    price: "41,400.00",
    mrp: "45,409.00",
    discount: "9%(₹4,009)",
    id: 4,
  },
  {
    name: "Lenovo LJIN IdeaPad 3 Laptop (11th Gen Intel Core i3-1115G4/8GB/512GB SSD/Intel UHD Graphics/Windows 11/MSO/Full HD), 39.62 cm (15.6 inch)",
    img: "https://www.reliancedigital.in/medias/Lenovo-LJIN-Laptops-492574616-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w2ODcxN3xpbWFnZS9qcGVnfGltYWdlcy9oYjAvaGJiLzk3NDE1NjMzOTYxMjYuanBnfDk3NmMzMWI4MDZjYzU0YzJmZGUxNTJiYzI0MGRjOTQ5Nzg5ZjI1YmM3NzNmNmE3NjQ3ZTQ0NzlhMzI2ZDNlYzU",
    price: "40,499.00",
    mrp: "65,690.00",
    discount: "38%(₹25,191)",
    id: 5,
  },
  {
    name: "Lenovo IdeaPad 3 Thin and Light Laptop (11th Gen Intel Core i3-1115G4/8 GB/512 GB SSD/Windows 11 Home/MSO/FHD), 39.62 cm (15.6 Inch)",
    img: "https://www.reliancedigital.in/medias/Lenovo-82H802L3IN-Laptop-493177740-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNTg4M3xpbWFnZS9qcGVnfGltYWdlcy9oZjcvaDk4Lzk4OTQ2NDQyNTI3MDIuanBnfDUwOTkxZTdiMWYxZjVmY2M3YWI3NDRhZDVjYjViYzMwNzZjZDE4OTk4NGM2YjM2YjkxZmE5OGU5NTgxYzI3NDg",
    price: "38,990.00",
    mrp: "67,090.00",
    discount: "42%(₹28,100)",
    id: 6,
  },
  {
    name: "HP 15s-fq2672TU Laptop (11th Gen Intel Core i3-1115G4/8GB RAM/512GB SSD/UHD Graphics/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 Inch), Natural Silver",
    img: "https://www.reliancedigital.in/medias/HP-6N045PA-ACJ-Laptop-492850808-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzMDMwM3xpbWFnZS9qcGVnfGltYWdlcy9oMzEvaGZjLzk4NjQyNzcyMjk1OTguanBnfGE5ZjgwMzdjYzY2MTAyMzhiZWRmNzM3OWI0NTNiMWI2MjcyNTRjMjIwNmY5ZmVlMmQwMDE3MjEyNzVmMDRmMTg",
    price: "43,749.00",
    mrp: "49,977.00",
    discount: "12%(₹6,228)",
    id: 7,
  },
  {
    name: "HP 15s-fq2671TU Laptop (11th Gen Intel Core i3-1115G4/8 GB RAM/512 GB SSD/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 inch)",
    img: "https://www.reliancedigital.in/medias/Hp-6N044PA-ACJ-Laptop-493177596-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyOTYwMHxpbWFnZS9qcGVnfGltYWdlcy9oYTIvaDMwLzk4ODIyOTA4NDc3NzQuanBnfDgzNzE4ZTExMDNkZmY1YmM2MzQyMWUwY2Y2NGRjMTA1MDJjNDVkNjQ5MTk0ZWIyMTA2NWQwY2I2MWNjOGQzZWI",
    price: "39,999.00",
    mrp: "47,833.00",
    discount: "16%(₹7,834)",
    id: 8,
  },
  {
    name: "Asus EK522WS Laptop (11th Gen Intel Core i5-1135G7/8 GB/512 GB SSD/Iris Xe Graphics/Windows 11 Home/MSO/FHD), 35.56 cm (14 Inch)",
    img: "https://www.reliancedigital.in/medias/Asus-X415EA-EK522WS-Laptop-493178259-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNTUyNHxpbWFnZS9qcGVnfGltYWdlcy9oZWQvaDM5Lzk5MDQ3MzE1MjEwNTQuanBnfDk2NmRmZTZjNzNiMTlkMjgwMWJiM2E0NjdmOTM4NzJjM2Y5ZTAyZmJmMjZhYmIxYmJjZTVjYzNkMDlmMDE1YWQ",
    price: "49,999.00",
    mrp: "70,990.00",
    discount: "30%(₹20,991)",
    id: 9,
  },
  {
    name: "HP 15s-fq5111TU Laptop (12th Gen Intel Core i5-1235U/8 GB RAM/512 GB SSD/Windows 11 Home/MSO/FHD), 39.6 cm (15.6 inch)",
    img: "https://www.reliancedigital.in/medias/Hp-6P129PA-ACJ-Laptop-493177598-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyOTYxMnxpbWFnZS9qcGVnfGltYWdlcy9oMzIvaDBjLzk4ODIyODk4NjQ3MzQuanBnfDc4ZGI4NTAzOGE1MWFhMTkyZTUxNGEzNjhlYTExMTA5YjEwNDFkNjVjNWVhNTAzZTkxNDE0YTNhZWFiZTIwZGQ",
    price: "57,928.00",
    mrp: "67,831.00",
    discount: "15%(₹9,903)",
    id: 10,
  },
];

export const SwiperData3 = [
  {
    name: "Samsung 1.5 Ton 5 Star 5 in 1 Convertible Inverter Split AC, AR18BYNZAUR (100 percent Copper, Anti-Bacteria Filter, Auto Clean Function, Filter clean indicator, 2022 Launch)",
    img: "https://www.reliancedigital.in/medias/Samsung-AR18BYLZAUR-Split-Air-Conditioner-581026959-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMzEzM3xpbWFnZS9qcGVnfGltYWdlcy9oY2UvaDJmLzk4MTMxMjgzODA0NDYuanBnfDZiNDIwMGUzODlmMDAyNjkyNTYyNzA2MTIxN2FiM2M4M2ViZTk3ZTJlOThhNTFlMzJjNDQ0ZmYwMmQwMDkwNGE",
    price: "36,990.00",
    mrp: "65,990.00",
    discount: "44%(₹29,000)",
    id: 1,
  },
  {
    name: "Hisense 1.5 Ton 4 Star, 4 in 1 Convertible Intelligent Inverter Split AC, AS-18TC4RAM0 (100 Percent Copper, PM 2.5 Filter + 3 in 1 Vitacarb Filter, Eco Friendly R-32 gas)",
    img: "https://www.reliancedigital.in/medias/HISENSE-AS-18TC4RAM0-Air-Conditioners-581026857-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyMzQ1MnxpbWFnZS9qcGVnfGltYWdlcy9oNDMvaDU1Lzk4MTAwNjU0NTcxODIuanBnfDM0MGU2NWE2YjZlNmI2YWZlYWUwMmRlYWNjYjU5ZThhMmYzNGIxOTFhYTNmN2E0ZTY2ZWQ4ODY5MTAxNGI2MWI",
    price: "29,990.00",
    mrp: "47,990.00",
    discount: "38%(₹18,000)",
    id: 2,
  },
  {
    name: "LG 1.5 Ton 5 Star AI 6 in 1 Super Convertible Smart WiFi Inverter Split AC, PS-Q19GWZF (Copper Condenser, 4 Way Swing, Anti-Allergy Filter, Ocean Black Fins, 2022 Launch)",
    img: "https://www.reliancedigital.in/medias/LG-PS-Q19GWZF-SPLITAIRCONS-581026758-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMTU4MXxpbWFnZS9qcGVnfGltYWdlcy9oNTAvaGU0Lzk3NjM1NDEyMjE0MDYuanBnfDgyOGVmZGUxMGU5NzA5NTAwOTQ2MzQ3Yjc2NDJmNWNhNTk1MzQ4MzA0ODBjMDZkYTM4ZGY3ZmE2ZjM4OWMxZmY",
    price: "47,990.00",
    mrp: "77,990.00",
    discount: "38%(₹30,000)",
    id: 3,
  },
  {
    name: "Samsung 1.5 Ton 4 Star Hot & Cold Series AR18BX4ZAWK Inverter Split AC",
    img: "https://www.reliancedigital.in/medias/Samsung-AR18BX4ZAWK-Split-Air-Conditioner-581026971-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMjg5MHxpbWFnZS9qcGVnfGltYWdlcy9oNWMvaDViLzk4MTMxNTQzMzI3MDIuanBnfDg5NzAyNGRkNWRhZmQyMTdkYWQxNmY4YTRjOTlmNjNmYTZkZTM2MmIxZThmN2RkZTRmZWQ4ZDJmZGZkN2Y4ZGI",
    price: "39,990.00",
    mrp: "53,890.00",
    discount: "26%(₹13,900)",
    id: 4,
  },
  {
    name: "LLOYD 1.5 Ton 5 Star Inverter Split AC, GLS18I5FWGEL (100 Percent Copper,Rapid Cooling,Golden fin condenser,Valve protection cover,2022 Launched)",
    img: "https://www.reliancedigital.in/medias/LLOYD-GLS18I5FWGEL-Split-Air-Conditioner-581026910-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMjIzOXxpbWFnZS9qcGVnfGltYWdlcy9oMmQvaDM0Lzk4MjQzNjMxMTg2MjIuanBnfDExMzI3Nzc4NjlhZmE5OGEyMGZhYWFhZGM2NjQ1ZjNiMTBiYjRjNmI1Y2IwNzA1NDZjY2Q5ZDg4MTNjNjYyZTc",
    price: "41,990.00",
    mrp: "60,990.00",
    discount: "31%(₹19,000)",
    id: 5,
  },
  {
    name: "Haier 1.5 Ton 3 Star Triple Inverter+ Split AC, HSU18C-NBS3B (100 percent Copper, 50 Feet Airflow, Hyper PCB, Cools even at 60‚C Ambient Temperature,Self Clean technology)",
    img: "https://www.reliancedigital.in/medias/Haier-HSU18C-NBS3B-Split-Air-Conditioner-581026955-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxMjQ4MnxpbWFnZS9qcGVnfGltYWdlcy9oY2QvaDcwLzk4MTY5ODgyODcwMDYuanBnfGIyMDUwY2ZjMGVmYzY2MmY2YzI2ZDJjYjllMmI3NTYzNzE5MzBhYTI2MWZlZjA2NTdhZjVmNTc4OTdlODAwZmE",
    price: "35,990.00",
    mrp: "65,490.00",
    discount: "45%(₹29,500)",
    id: 6,
  },
  {
    name: "Samsung 1.5 Ton 3 Star AR18BY3YATA Inverter, Split AC, HD Filter, 2 Way Swing, Floral Design, 5 in 1 Convertible (2022 Launch)",
    img: "https://www.reliancedigital.in/medias/SAMSUNG-AR18BY3YATA-Split-Air-conditioner-581026749-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxODU0MXxpbWFnZS9qcGVnfGltYWdlcy9oZTAvaDNhLzk3ODUxMTQ4NTM0MDYuanBnfGU3NDE2YzcxNTkzMDRiYTA2OGQ4YTMxZWQyNjdlMjJkYjk2NjRjNmZjMDM2YjMyNmQ5YTEzOTZlZTNjNmU0ZTg",
    price: "38,490.00",
    mrp: "58,990.00",
    discount: "35%(₹20,500)",
    id: 7,
  },
  {
    name: "HAIER 1.5 Ton 3 Star Split AC, TurboCool HSU18T-TQS3B (Copper Condenser, Micro Dust Filter, Cools even at 54C, R32 Eco friendly Gas, 2022 Launched)",
    img: "https://www.reliancedigital.in/medias/HAIER-HSU18T-TQS3B-Split-ACs-581027005-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzNTI3fGltYWdlL2pwZWd8aW1hZ2VzL2g5Ny9oNzMvOTgzNTQ3MDkxMzU2Ni5qcGd8M2QzMjY5NjA4NTFiOTYwMjkxZWI2Njk3YjkzNzkzOTcxNmIzYTMxYWYzODEzZGJjN2QxOTIwN2M3OGFjNjE3OQ",
    price: "32,990.00",
    mrp: "60,890.00",
    discount: "46%(₹27,900)",
    id: 8,
  },
  {
    name: "Kelvinator 1.5 Ton 3 Star K600+ Series KAS-X18320P Inverter Split AC with Single Rotary Compressor",
    img: "https://www.reliancedigital.in/medias/Kelvinator-KAS-X18320P-SPLIT-AIRCONS-581026690-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNTc4OXxpbWFnZS9qcGVnfGltYWdlcy9oOTMvaDhmLzk4MDg4Mjg0NjUxODIuanBnfGI4NWU0ZDVmNTlkZDdlYmRmYzA0YjQ0MTZlNDZhNDMwMTJhNjk1M2FkMzY3ZTc1ZjIzYTlkNmNiMTk4MWVhNzk",
    price: "31,990.00",
    mrp: "50,490.00",
    discount: "37%(₹18,500)",
    id: 9,
  },
  {
    name: "Samsung 1.5 Ton 5 Star AR18BY5YATZ Inverter Split AC, Wi-Fi, Tri Care Filter, 4 way Swing, Floral Design, 5 in 1 Convertible (2022 Launch)",
    img: "https://www.reliancedigital.in/medias/SAMSUNG-AR18BY5YATZ-Split-Air-conditioner-581026781-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxNTcxNXxpbWFnZS9qcGVnfGltYWdlcy9oNmMvaDk2Lzk3ODUwOTIzNzQ1NTguanBnfDE3MWI1YjRlMjgwZDY1ZTAyN2E5YzJlMjJkOWExNDQ2Y2IyYWU5MGY1MjVhZWQ0NzZhYzEyNDAyZTkyMzhhYjI",
    price: "47,990.00",
    mrp: "70,990.00",
    discount: "32%(₹23,000)",
    id: 10,
  },
];
export const SwiperData4 = [
  {
    name: "BPL Men's 10-in-1 Grooming Kit with Digital Battery Indicator, 70mins Cordless Usage, Fast Charging, 5-Heads & 5-Comb Length Adjustment, Detachable Heads for easy cleaning, 2 Years Warranty, Black and Light Gold",
    img: "https://www.reliancedigital.in/medias/BPL-BBTD001GK-Shaver-and-Trimmers-491903184-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0Mjc2M3xpbWFnZS9qcGVnfGltYWdlcy9oZGEvaDUwLzk2MjExMzQwMTY1NDIuanBnfDU4YWM2ZDBiZDQwNjM5ZjEwMzQ0ZjEyMTU0OWZmM2MzOWUzZDVlZmI0NDUwYTU1YTdlYzIxMzRjYmRmMmQwOGE",
    price: "999.00",
    mrp: "2,799.00",
    discount: "64%(₹1,800)",
    id: 1,
  },
  {
    name: "Lifelong LLPCM13 Men's Beard Trimmer, Black",
    img: "https://www.reliancedigital.in/medias/Lifelong-LLPCM13-Shavers-and-Trimmers-491903024-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyODc3NHxpbWFnZS9qcGVnfGltYWdlcy9oMzYvaDRjLzk0NzA5MjU4NjQ5OTAuanBnfDIyNzNmNDU2ZmQwYTE0MTBlM2I4ZTk3MjdkNWFkZWQ1YmFiMmMxNzMyMzlhMjFmY2Y3OWY3YTFkNWIyMjg1ZjA",
    price: "559.00",
    mrp: "1,200.00",
    discount: "53%(₹641)",
    id: 2,
  },
  {
    name: "Philips BT3102/15 cordless rechargeable Beard Trimmer - 10 length settings, 60 min run time",
    img: "https://www.reliancedigital.in/medias/Philips-BT3102-15-Shaver-and-Trimmers-491891822-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wxOTE5NHxpbWFnZS9qcGVnfGltYWdlcy9oMjAvaDJmLzkzMzI2NjMxMjM5OTguanBnfDcwNDg1ZTA4OTg0MzllNzFjMDU3MDk2N2Q3NWJmMTUzZGE1MzZlOGNhY2VjZjllOTU3OTM2YjFkZDYzOGJkZWQ",
    price: "1,249.00",
    mrp: "1,495.00",
    discount: "16%(₹246)",
    id: 3,
  },
  {
    name: "Misfit by boAt T30 RTL Men's Trimmer, Active Black",
    img: "https://www.reliancedigital.in/medias/MISFIT-T30-Trimmer-492910929-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0MjIxfGltYWdlL2pwZWd8aW1hZ2VzL2g4OS9oNDMvOTgxNzQwMTEzMTAzOC5qcGd8MzQ4ZjBiZmQwNzA0YTUxOTQ0OWZlYWQ5ZmFiZWMwZTI4YzYwMTEwMDRmY2FlNmY1ZTc0NTE4MjFjZjRkMzNkNg",
    price: "449.00",
    mrp: "1,499.00",
    discount: "70%(₹1,050)",
    id: 4,
  },
  {
    name: "Wahl Cordless Trimmer Mini Groomsman 3 in 1 Grooming Kit, 05608-524 Black",
    img: "https://www.reliancedigital.in/medias/WAHL-05608-524-Trimmers-491891812-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyNDQ4OXxpbWFnZS9qcGVnfGltYWdlcy9oNmYvaDZiLzkzNzQ2NTAyMzY5NTguanBnfDI0NDY2NDIwZGRhYWNhYTBiZTU2YjVkOWUzYzk3NzYxODUxNzc4MTgyNGYxYzU2YTM2MTdiYzZiZjhhYWQ1ZGU",
    price: "199.00",
    mrp: "1,000.00",
    discount: "80%(₹801)",
    id: 5,
  },
  {
    name: "Philips Beard Trimmer BT1230/15 with USB Charging",
    img: "https://www.reliancedigital.in/medias/Philips-BT1230-15-TRIMMER-492664323-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w1MzcyfGltYWdlL2pwZWd8aW1hZ2VzL2g1OS9oYjkvOTc0OTU4NTc4ODk1OC5qcGd8M2JlNGNiNjc3MDUxODY2ZjAwMGQyODE2NTdiOTZkZmM2ODY5Yjg4NDMyMDc0ZDQ1MTE3MWIzMDg0NjgxNTM2NQ",
    price: "699.00",
    mrp: "945.00",
    discount: "26%(₹246)",
    id: 6,
  },
  {
    name: "Wahl Grooming Kit Mini T Pro, White and Black",
    img: "https://www.reliancedigital.in/medias/WAHL-Mini-T-Pro-Trimmers-492910963-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w1Mjg3OHxpbWFnZS9qcGVnfGltYWdlcy9oMzQvaGNhLzk4MjkwMjQxMDQ0NzguanBnfDIwM2FlYWE3YjVjMjY1YTE4MmI1MTlmMGI1NWZmYmU3NzAzZjRkMTE5MThmMjI3YjNjMGQyMzBjZGQ1MDk1NWM",
    price: "799.00",
    mrp: "1,649.00",
    discount: "52%(₹850)",
    id: 7,
  },
  {
    name: "Phillips 7000 13-in-1 Multigroom Trimmer with Self-sharpening Blades, MG7715/65",
    img: "https://www.reliancedigital.in/medias/Philips-MG7715-65-Trimmer-492864867-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzNTE0OXxpbWFnZS9qcGVnfGltYWdlcy9oZWIvaDdiLzk4MzE3NzM5Mjk1MDIuanBnfGRiNGVlMmNlMjdhYzdlNjQ2Mzg1MjY2ZTBkODU5OGZiZWVjZDRiZDkwMDk1MzdlMTRiOTNlMjk1OTFiYjA1NWQ",
    price: "3,492.00",
    mrp: "4,595.00",
    discount: "24%(₹1,103)",
    id: 8,
  },
  {
    name: "Philips MG5740/15 Grooming Kit with Self-sharpening blades & 12 tools",
    img: "https://www.reliancedigital.in/medias/Philips-MG5740-15-TRIMMER-492391977-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wzMjE5M3xpbWFnZS9qcGVnfGltYWdlcy9oOWYvaDMzLzk3NzU4NzYyNzYyNTQuanBnfDFmZTc4NzYyODQ5ODcwNGI0MmZiNDk3YTIyYTY0OTNjYjQ4NzA4NmE3ODgwMzAwYTU0NTk3Mzg5ZDVlYzg4N2Y",
    price: "2,399.00",
    mrp: "2,995.00",
    discount: "20%(₹596)",
    id: 9,
  },
  {
    name: "Wahl Quickstyle Men's Trimmer, Grey",
    img: "https://www.reliancedigital.in/medias/WAHL-Quickstyle-Trimmers-491189131-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3wyOTI2NHxpbWFnZS9qcGVnfGltYWdlcy9oYmMvaGUzLzk4NjU1Nzc0NjM4MzguanBnfGFlZWJiNzg0YmM2M2E5ZTVmMTY0YTRiYjcyMzI0MzE5ZDIxYjJhODQwNmJlN2VjMmUzZjY2ZjQzYTQ5MDg5NzQ",
    price: "449.00",
    mrp: "1,095.00",
    discount: "59%(₹646)",
    id: 10,
  },
];
